import axios from 'axios';

export default axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 50000, // miliseconds
  maxContentLength: -1,
  headers: {
    'Content-Type': 'application/json',
    'x-sbk': process.env.VUE_APP_API_SBK,
    // TODO: Create needed headers to OPEN_MODULES_API
    // TODO: Certificate usage (?)
  }
});